module.exports = __webpack_public_path__ + "static/img/3.0a721bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/zh/3.png
// module id = pOHt
// module chunks = 0